// 收付款 关联 订单金额
<template>
  <div class="clearfix">
    <div class="modal-header sel-modal-header clearfix">
      <vxe-radio-group v-model="cate" size="medium">
        <ul class="tab-list">
          <li v-if="cate == 'Collection'">
            <vxe-radio name="xtabs" label="Collection">托运人订单</vxe-radio>
          </li>
          <li v-if="cate == 'Payment' || cate == 'SellerPayment'">
            <vxe-radio name="xtabs" label="Payment">承运人订单</vxe-radio>
          </li>
          <li v-if="cate == 'Payment' || cate == 'SellerPayment'">
            <vxe-radio name="xtabs" label="SellerPayment"
              >实际供应方订单
            </vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="my-search">
        <vxe-input
          v-model="searchOrdersNum"
          style="width: 200px"
          type="search"
          placeholder="输入订单号"
          @search-click="search"
          @keyup.enter.native="search"
        ></vxe-input>
        <vxe-input
          v-model="searchOrdersName"
          type="search"
          :placeholder="
            cate === 'Collection'
              ? '请输入托运人名称'
              : cate === 'Payment'
              ? '请输入承运人名称'
              : '请输入实际承运人名称'
          "
          @search-click="search"
          @keyup.enter.native="search"
          style="width: 200px; margin-left: 20px"
        ></vxe-input>
      </div>
    </div>

    <div class="add-box clearfix">
      <vxe-table
        border="none"
        show-overflow
        keep-source
        class="table-style"
        align="center"
        ref="xTable"
        max-height="450"
        highlight-hover-row
        :data="tableData"
        :loading="loading"
        :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
        @cell-click="cellClick"
        @checkbox-change="checkboxChange"
        @checkbox-all="checkBoxAll"
      >
        <vxe-table-column
          type="checkbox"
          field="checked"
          align="center"
          width="60"
        ></vxe-table-column>
        <vxe-table-column field="aboutAmount" title="关联金额" width="150">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.aboutAmount"
              placeholder="输入关联金额"
              v-on:input="inputAboutAmount(scope.row)"
              @input="$refs.xTable.updateStatus(scope)"
              v-if="scope.row.checked == true"
              type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="ordersNumb"
          title="子订单编号"
          width="130"
        ></vxe-table-column>
        <vxe-table-column
          field="contractTitle"
          title="订单标题"
          width="120"
        ></vxe-table-column>
        <vxe-table-column
          field="buyerName"
          title="托运人名称"
          width="200"
        ></vxe-table-column>
        <vxe-table-column
          field="sellerName"
          title="承运人名称"
          width="200"
        ></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="105">
          <template slot-scope="{ row, $rowIndex }">
            <div style="height: 24px">
              <div v-if="row.goodsRtnVos">{{ row.goodsName }}</div>
              <Icon
                type="ios-arrow-down"
                @click.stop="toggleGoods($rowIndex)"
                v-if="row.goodsRtnVos && row.goodsRtnVos.length > 1"
              />
              <vxe-pulldown :ref="$rowIndex" placement="bottom" transfer>
                <template v-slot:dropdown>
                  <div class="my-dropdown3">
                    <vxe-table
                      auto-resize
                      :data="row.goodsRtnVos"
                      stripe
                      show-overflow
                      max-height="480"
                      align="center"
                    >
                      <vxe-table-column
                        field="goodsName"
                        title="货名"
                        width="104"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="unit"
                        title="单位"
                        width="75"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="counts"
                        title="数量"
                        width="75"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="price"
                        title="单价"
                        width="75"
                      ></vxe-table-column>
                      <vxe-table-column field="isTax" title="含税" width="75">
                        <template slot-scope="{ row }">
                          <span>{{ row.isTax | taxMap }}</span>
                        </template>
                      </vxe-table-column>
                      <vxe-table-column
                        field="carShipNum"
                        title="车船号"
                        width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="beginPlace"
                        title="起运地"
                        width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="endPlace"
                        title="到达地"
                        width="90"
                      ></vxe-table-column>
                      <vxe-table-column
                        field="beginTime"
                        title="受载/起运时间"
                        width="140"
                      >
                        <template slot-scope="{ row }">
                          <span>{{ row.beginTime | timeFormatDate }}</span>
                        </template>
                      </vxe-table-column>
                    </vxe-table>
                  </div>
                </template>
              </vxe-pulldown>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="rule"
          title="规格"
          width="75"
        ></vxe-table-column>
        <vxe-table-column
          field="unit"
          title="单位"
          width="75"
        ></vxe-table-column>
        <vxe-table-column
          field="counts"
          title="数量"
          width="75"
        ></vxe-table-column>
        <vxe-table-column
          field="price"
          title="单价"
          width="75"
        ></vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="75">
          <template slot-scope="{ row }">
            <span>{{ row.isTax | taxMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="carShipNum"
          title="车船号"
          width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="beginPlace"
          title="起运地"
          width="100"
        ></vxe-table-column>
        <vxe-table-column
          field="endPlace"
          title="到达地"
          width="100"
        ></vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createUser"
          title="创建人"
          width="100"
        ></vxe-table-column>
        <vxe-table-column field="createTime" title="创建日期" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.createTime | timeFormatDate }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div>
      <vxe-pager
        style="margin-top: 20px"
        background
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="page.totalResult"
        @page-change="changePage"
      ></vxe-pager>
    </div>

    <div class="footer-wrap" style="margin-bottom: 15px">
      <Button status="primary" @click="submit(true)">提交</Button>
      <div>
        <span>可关联金额为:</span> ¥
        <span style="color: blue">{{ payAmount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { isEmpty, isNotEmpty } from "@/utils/util";
import { numberToCurrency, numberToMoney } from "@/filters/type";

export default {
  name: "PaymentAboutOrder",
  props: {
    chainId: [String, Number],
  },
  data() {
    return {
      cate: "", // 选择的订单类型,  Collection 购买方订单  Payment SellerPayment 承运人订单
      platformCompanyId: "", //所属平台
      searchOrdersNum: "", //搜索订单号
      searchOrdersName: "", //搜索托运人 或 承运人 实际承运人 名称
      platformCompany: null,
      buyerName: "",
      loading: false,
      payAmount: 0,
      tableData: [],
      isCheckboxAll: false,
      checkboxConfig: {
        labelField: "操作",
        checkField: "checked",
      },
      currentPage: 0,
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      resMoneyMap: {},
    };
  },
  watch: {
    cate: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (oldVal) {
          if (val == "Payment" || val == "SellerPayment") {
            this.getOrderList();
          }
        }
      },
    },
  },
  methods: {
    init(
      cate,
      paymentsId,
      payAmount,
      ordersList,
      platformCompanyId,
      buyerName,
      platformCompany
    ) {
      if (ordersList && ordersList.length > 0) {
        ordersList.map((i) => {
          i.salesManName = i.salesMan;
          i.salesMan = i.salesManId;
        });
      }
      this.page.currentPage = 1;
      this.isCheckboxAll = false;
      this.cate = cate;
      this.platformCompanyId = platformCompanyId;
      this.platformCompany = platformCompany;
      this.paymentsId = isEmpty(paymentsId) ? 0 : paymentsId;
      this.payAmount = payAmount;
      this.ordersList = isEmpty(ordersList) ? [] : ordersList;
      this.buyerName = buyerName;
      this.searchOrdersNum = "";
      this.searchOrdersName = "";

      this.resMoneyMap = {};
      this.ordersList.forEach((item) => {
        if (isNotEmpty(item.ordersId)) {
          item.checked = true;
          this.resMoneyMap[item.ordersId] = item;
        }
      });

      this.getOrderList();
    },
    changePage(e) {
      if (!this.submit()) {
        this.page.currentPage = this.currentPage === 0 ? 1 : this.currentPage;
        return;
      }

      this.page.pageSize = e.pageSize;
      if (this.currentPage != e.currentPage) {
        this.currentPage = e.currentPage;
        this.getOrderList();
      }
    },
    search() {
      this.page.currentPage = 1;
      this.getOrderList();
    },
    async getOrderList() {
      // 获取列表数据
      this.loading = true;
      let params = {
        paymentsId: this.paymentsId,
        // platformCompanyId: this.platformCompanyId,
        // buyerName: this.buyerName,
        page: this.page.currentPage,
        rows: this.page.pageSize,
        orderBy: 2,
      };
      //v-if="cate == 'Payment' || cate == 'SellerPayment'"
      if(this.cate == 'SellerPayment') {
        params.buyerName = this.platformCompany
      } else {
        params.platformCompanyId = this.platformCompanyId
      }
      //搜索的参数
      if (this.searchOrdersNum) {
        if (this.cate == "Collection") {
          params.buyerOrdersNum = this.searchOrdersNum;
        } else {
          params.sellerOrdersNum = this.searchOrdersNum;
        }
      }
      if (this.searchOrdersName) {
        if (this.cate == "Collection") {
          params.buyerName = this.searchOrdersName;
        } else {
          params.sellerName = this.searchOrdersName;
        }
      }
      let res;
      if (this.cate == "Collection") {
        res = await $api.order.post("queryOrdersBuyerRelatedMoneyList", params);
      } else {
        params.isRealSeller = this.cate == "Payment" ? 0 : 1;
        res = await $api.sellerOrder.post(
          "queryOrdersSellerRelatedMoneyList",
          params
        );
      }

      if (res.status != 1) {
        if (isEmpty(res.message)) res.message = "接口异常";
        this.$refs.$XModal.message(res.mesage);
        return;
      }

      let tableData = res.data.rows;
      this.isCheckboxAll = true;
      tableData.map((i) => {
        if (this.cate == "Collection") {
          i.ordersNumb = i.buyerOrdersNum;
        } else {
          i.ordersNumb = i.sellerOrdersNum;
        }
        if (
          isNotEmpty(this.resMoneyMap[i.id]) &&
          isNotEmpty(this.resMoneyMap[i.id].aboutAmount)
        ) {
          i.relatedAmount = this.resMoneyMap[i.id].aboutAmount;
          i.aboutAmount = i.relatedAmount;
        } else {
          i.aboutAmount = null;
        }

        if (isEmpty(i.aboutAmount)) {
          i.checked = false;
          this.isCheckboxAll = false;
        } else {
          i.checked = true;
        }

        if (i.goodsRtnVos && i.goodsRtnVos.length > 0) {
          i.goodsName = i.goodsRtnVos[0].goodsName;
          i.rule = i.goodsRtnVos[0].rule;
          i.unit = i.goodsRtnVos[0].unit;
          i.counts = i.goodsRtnVos[0].counts;
          i.price = i.goodsRtnVos[0].price;
          i.isTax = i.goodsRtnVos[0].isTax;
          i.carShipNum = i.goodsRtnVos[0].carShipNum;
          i.beginPlace = i.goodsRtnVos[0].beginPlace;
          i.endPlace = i.goodsRtnVos[0].endPlace;
          i.beginTime = i.goodsRtnVos[0].beginTime;
          i.createTime = i.goodsRtnVos[0].createTime;
        }
      });
      this.tableData = tableData;
      this.page.totalResult = res.data.total;

      if (isNotEmpty(this.$refs.xTable)) {
        tableData.forEach((row) => {
          if (row.checked == true) {
            this.$refs.xTable.setCheckboxRow(row, true);
          }
        });
      }
      this.loading = false;
    },
    cellClick(e) {},
    checkboxChange({ row, $rowIndex }) {
      row.checked = row.checked == true ? false : true;
      let data = this.$refs.xTable.getCheckboxRecords();
      if (data.length === 1 && row.checked == true) {
        this.resMoneyMap[row.id] = row;
        row.aboutAmount = this.payAmount;
      }
      if (row.checked === false && isNotEmpty(this.resMoneyMap[row.id])) {
        delete this.resMoneyMap[row.id];
      }
      if (row.checked === false) {
        this.isCheckboxAll = false;
      }
    },
    checkBoxAll(e) {
      this.isCheckboxAll = this.isCheckboxAll == true ? false : true;
      this.tableData.forEach((item) => (item.checked = this.isCheckboxAll));
      if (this.isCheckboxAll == false) {
        this.tableData.forEach((item) => {
          item.aboutAmount = null;
          if (isNotEmpty(this.resMoneyMap[item.id])) {
            delete this.resMoneyMap[item.id];
          }
        });
      }
      this.$refs.xTable.updateStatus();
    },
    inputAboutAmount(row) {
      row.checked = true;
      this.resMoneyMap[row.id] = row;
    },
    toggleGoods(id) {
      this.$refs[id].togglePanel();
    },
    submit(isSubmit) {
      if (this.cate == 'Collection') {
        let arr = []
        for (var id in this.resMoneyMap) {
          let item = this.resMoneyMap[id].buyerName;
          arr.push(item)
        }
         arr = [...new Set(arr)]
         if (arr.length > 1) {
           this.$XModal.message({ message: "关联的订单托运人不一致，请核对" });
           return
         }
      }
      let usedAmount = 0;
      let resAmountList = [];
      //选中关联金额要填
      var errMsg = "";
      let payAmount = Math.round(this.payAmount * 100) / 100;
      this.tableData.forEach((item) => {
        let itemAboutAmount = Math.round(item.aboutAmount * 100) / 100;

        if (item.checked == true) {
          if (isEmpty(item.aboutAmount)) {
            errMsg = "请填写关联金额";
          } else if (
            isNaN(parseFloat(item.aboutAmount)) ||
            (payAmount > 0 && itemAboutAmount < 0) ||
            (payAmount < 0 && itemAboutAmount > 0)
          ) {
            errMsg = "关联金额错误";
          }
        }
      });

      if (isNotEmpty(errMsg)) {
        this.$XModal.message({ message: errMsg });
        return false;
      }

      //整理关联数据
      for (var ordersId in this.resMoneyMap) {
        let item = this.resMoneyMap[ordersId];
        if (item.checked == true) {
          if (isEmpty(item.aboutAmount) || item.aboutAmount == 0) {
            this.$XModal.message({ message: "请填写关联金额" });
            return false;
          } else {
            // console.log(item, 'aaa');
            // debugger
            resAmountList.push({
              id: item.id,
              ordersId: ordersId,
              ordersNumb: item.ordersNumb,
              chainNum: item.chainNum,
              buyerName: item.buyerName,
              sellerName: item.sellerName,
              rateManage: item.rateManage,
              aboutAmount: parseFloat(item.aboutAmount),
              salesManName: item.salesManName,
              salesManId: item.salesMan,
            });

            usedAmount += parseFloat(item.aboutAmount);
          }
        }
      }
      if (
        (payAmount > 0 &&
            Math.round(usedAmount * 100) > Math.round(this.payAmount * 100)) ||
        (payAmount < 0 &&
            Math.round(usedAmount * 100) < Math.round(this.payAmount * 100))
      ) {
        let message =
          this.cate == "Collection"
            ? "关联金额不能超过收款金额"
            : "关联金额不能超过付款金额";
        this.$XModal.message({ message });
        return false;
      }
      if (usedAmount > 0) usedAmount = parseInt(usedAmount * 100) / 100;

      if (isSubmit) {
        // console.log(resAmountList);
        // debugger
        this.$emit("choose", resAmountList, usedAmount);
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.vxe-pager .vxe-pager--wrapper {
  position: relative;
}

.vxe-pager .vxe-pager--sizes {
  height: 28px !important;
}

.modal-header {
  position: relative;
  height: 60px;
}

.my-search {
  padding: 10px;
  position: absolute;
  right: 0;
  top: 0;
}

.my-search .vxe-input {
  height: 34px;
  width: 400px;
}

.my-search .vxe-input >>> .vxe-input--suffix {
  display: block !important;
  width: 60px;
  height: 32px;
  top: 1px;
  text-align: center;
  border-left: 1px solid #dcdfe6;
  background-color: #f5f7fa;
  cursor: pointer;
}

.my-search .vxe-input >>> .vxe-input--inner {
  border: 1px solid #dcdfe6;
}

.btn-down {
  border: none;
  background: transparent;
}

.btn-down:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
}

.link-text {
  margin-right: 30px;
  margin-left: 10px;
}

.ivu-btn.ivu-btn-primary {
  width: 140px;
  height: 40px;
}
</style>